import { render } from "@/components/pages/dataRecollection/DataRecollection.html?vue&type=template&id=9dca61ca&external"
import script from "@/components/pages/dataRecollection/DataRecollection.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/DataRecollection.js?vue&type=script&lang=js&external"

import "@/components/pages/dataRecollection/DataRecollection.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__